import SendBillScreen from "./SendBillScreen";

export default SendBillScreen;
